import cn from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Typography, Tooltip } from '@scale/scaleui';

export function ColumnHeader({
  title,
  isGoldenPath,
  isResponseColumn = false,
}: {
  title: string;
  isGoldenPath: boolean;
  isResponseColumn?: boolean;
}) {
  return (
    <div
      className={cn(
        'p-2 px-4 rounded-md border  bg-neutral-0 flex items-center justify-between gap-2',
        {
          'border-primary-300': isGoldenPath,
          'border-neutral-200': !isGoldenPath,
        },
      )}
    >
      <Typography.Subtitle3>{title}</Typography.Subtitle3>
      {isGoldenPath && (
        <Tooltip
          text="This column is along the selection path"
          target={
            isResponseColumn ? (
              <div className="text-primary-700 bg-primary-100 py-0.5 px-2.5 rounded-xl text-xs font-medium flex items-center">
                Selected
                <FontAwesomeIcon
                  icon="star"
                  className="text-primary-700 ml-0.5"
                  style={{ fontSize: 8 }}
                />
              </div>
            ) : (
              <div>
                <FontAwesomeIcon icon="star" className="text-primary-700" />
              </div>
            )
          }
        />
      )}
    </div>
  );
}
